import { RequestHelper } from '../../ts/helpers/RequestHelper';
import { GetMetricDataPointsByIdsRequest } from '../../ts/ServerApi/requests/GetMetricDataPointsByIdsRequest';
import { IMetricDataList } from '../../ts/ServerApi/types/IMetricDataList';
import { ErrorNotifyingServer } from '../../ts/services/ErrorNotifyingServer';
import { ServiceLocator } from '../../app/ServiceLocator';
import { RequestHeaders } from '../../ts/ServerApi/requests/Request';

export const MetricDataPoints = {
  getMetricDataPoints(metricIds: string[], headers?: RequestHeaders): ng.IPromise<IMetricDataList> {
    return ServiceLocator.get<ErrorNotifyingServer>('ErrorNotifyingServer').sendRequests(
      RequestHelper.buildRequests(metricIds, (metricIds) => new GetMetricDataPointsByIdsRequest({metricIds}, headers)),
      (results: IMetricDataList[]) => {
        return {
          failures: results.reduce((r, c) => Object.assign(r, c.failures), {}),
          data: results.reduce((r, c) => Object.assign(r, c.data), {}),
        };
      }
    );
  }
};

export type MetricDataPoints = typeof MetricDataPoints;
